export default {
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8181',
  s3BucketUrl: process.env.REACT_APP_S3_BUCKET_URL || 'http://localhost:4572/saavi',

  useNewBe: true,
  newBackendUrl: process.env.REACT_APP_NEW_BACKEND_URL || 'http://localhost:8080',
}
